import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 21l-4 -8l-4 8l4 -2z","key":"svg-0"}],["path",{"d":"M10 9v-6l4 6v-6","key":"svg-1"}]]

const IconNavigationNorth = createReactComponent('outline', 'navigation-north', 'NavigationNorth', __iconNode);

export default IconNavigationNorth;